import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;
export const API = `${BASE}/api`;

export const http = axios.create({ baseURL: API });

http.interceptors.request.use((config) => {
  const t = localStorage.getItem("koi_token");
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

http.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      localStorage.removeItem("koi_token");
      localStorage.removeItem("koi_user");
    }
    // Normalize FastAPI's 422 detail arrays into a friendly single-line string
    // so `toast.error(e?.response?.data?.detail)` renders correctly.
    const detail = err?.response?.data?.detail;
    if (Array.isArray(detail)) {
      err.response.data.detail = detail
        .map((d) => {
          const field = Array.isArray(d?.loc) ? d.loc[d.loc.length - 1] : "field";
          return `${field}: ${d?.msg || "invalid"}`;
        })
        .join(" · ");
    }
    return Promise.reject(err);
  }
);
